import { render, staticRenderFns } from "./OctSvg.vue?vue&type=template&id=6ed55e16&scoped=true&"
import script from "./OctSvg.vue?vue&type=script&lang=js&"
export * from "./OctSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed55e16",
  null
  
)

export default component.exports